import { Users, Filter, Heart } from "lucide-react";
interface FilteringFunnelProps {
  variant: "men" | "women";
}
const FilteringFunnel = ({
  variant
}: FilteringFunnelProps) => {
  const isDark = variant === "women";
  return <section className={`py-20 md:py-32 ${isDark ? "bg-navy-light" : "bg-cream-dark"}`}>
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className={`font-serif text-3xl md:text-4xl lg:text-5xl font-bold mb-4 ${isDark ? "text-cream" : "text-navy"}`}>
            המשפך שלנו
          </h2>
          <p className={`text-xl ${isDark ? "text-cream/70" : "text-muted-foreground"}`}>
            איך אנחנו מסננים עבורך
          </p>
        </div>

        {/* Funnel Visualization */}
        <div className="max-w-xl mx-auto mb-12">
          <div className="relative flex flex-col items-center gap-0">
            {/* Top Layer - 100 Applicants */}
            <div className={`relative w-full py-8 px-6 text-center transition-all duration-500 hover:scale-[1.02] ${isDark ? "bg-gradient-to-b from-cream/10 to-cream/5 border-t border-x border-cream/20" : "bg-gradient-to-b from-navy/10 to-navy/5 border-t border-x border-navy/20"}`} style={{
            clipPath: "polygon(0% 0%, 100% 0%, 90% 100%, 10% 100%)",
            borderRadius: "12px 12px 0 0"
          }}>
              <div className="flex items-center justify-center gap-3 mb-2">
                <Users className={`w-6 h-6 ${isDark ? "text-cream/70" : "text-navy/70"}`} />
                <span className={`font-serif text-2xl md:text-3xl font-bold ${isDark ? "text-cream" : "text-navy"}`}>
                  100 פניות
                </span>
              </div>
              <p className={`text-sm ${isDark ? "text-cream/50" : "text-muted-foreground"}`}>
                מועמדים שרוצים להצטרף למאגר
              </p>
            </div>

            {/* Middle Layer - Training & Screening */}
            <div className={`relative w-[80%] py-8 px-6 text-center transition-all duration-500 hover:scale-[1.02] ${isDark ? "bg-gradient-to-b from-gold/20 to-gold/10 border-x border-gold/30" : "bg-gradient-to-b from-gold/30 to-gold/15 border-x border-gold/40"}`} style={{
            clipPath: "polygon(0% 0%, 100% 0%, 85% 100%, 15% 100%)"
          }}>
              <div className="flex items-center justify-center gap-3 mb-2">
                <Filter className="w-6 h-6 text-gold" />
                <span className="font-serif text-xl md:text-2xl font-bold text-gold">
                  הכשרה וסינון
                </span>
              </div>
              <p className={`text-sm ${isDark ? "text-cream/60" : "text-muted-foreground"}`}>
                אימות זהות, ריאיון אישי, הערכה מקצועית
              </p>
            </div>

            {/* Bottom Layer - 1 Perfect Match */}
            <div className={`relative w-[55%] py-8 px-6 text-center transition-all duration-500 hover:scale-[1.02] ${isDark ? "bg-gradient-to-b from-gold/30 to-gold/20 border-x border-b border-gold/50" : "bg-gradient-to-b from-gold/40 to-gold/25 border-x border-b border-gold/60"}`} style={{
            clipPath: "polygon(0% 0%, 100% 0%, 70% 100%, 30% 100%)",
            borderRadius: "0 0 12px 12px"
          }}>
              <div className="flex items-center justify-center gap-3 mb-2">
                <Heart className="w-6 h-6 text-gold fill-gold/30" />
                <span className="font-serif text-xl md:text-2xl font-bold text-gold">
                  התאמה אחת מדויקת
                </span>
              </div>
              <p className={`text-sm ${isDark ? "text-cream/70" : "text-navy/70"}`}>
                בשבילך
              </p>
            </div>
          </div>
        </div>

        {/* Caption */}
        <div className="max-w-2xl mx-auto text-center">
          <p className={`text-lg md:text-xl leading-relaxed font-medium ${isDark ? "text-cream/90" : "text-navy"}`}>
            {variant === "women" 
              ? <>
                  "את משלמת לנו לומר
                  <span className="text-gold font-bold"> ׳לא׳ </span>
                  לאנשים הלא נכונים, כדי שתפגשי רק את הנכונים."
                </>
              : <>
                  "אתה משלם לנו לומר
                  <span className="text-gold font-bold"> ׳לא׳ </span>
                  לאנשים הלא נכונים, כדי שתפגוש רק את הנכונות."
                </>
            }
          </p>
        </div>
      </div>
    </section>;
};
export default FilteringFunnel;